import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@material-ui/core/styles";

const SettingsSection = ({ icon: Icon, title, children }) => {
  const theme = useTheme();
  const isDark = theme.palette.type === "dark";

  return (
    <Box
      sx={{
        borderRadius: "16px",
        overflow: "hidden",
        background: isDark
          ? "linear-gradient(135deg, rgba(24, 24, 27, 0.8) 0%, rgba(22, 22, 24, 0.6) 100%)"
          : "#ffffff",
        border: isDark
          ? "1px solid rgba(91, 124, 255, 0.15)"
          : "1px solid #dde2ea",
        boxShadow: isDark
          ? "0 4px 24px rgba(0,0,0,0.4)"
          : "0 1px 2px rgba(15, 23, 42, 0.06), 0 2px 8px rgba(15, 23, 42, 0.05)",
      }}
    >
      {/* Section header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          px: 3,
          py: 2,
          borderBottom: isDark
            ? "1px solid rgba(91, 124, 255, 0.1)"
            : "1px solid #f1f5f9",
        }}
      >
        {Icon && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: "8px",
              background: isDark
                ? "linear-gradient(135deg, rgba(91, 124, 255, 0.15), rgba(124, 58, 237, 0.15))"
                : "linear-gradient(135deg, rgba(61, 92, 253, 0.08), rgba(124, 58, 237, 0.08))",
              "& svg": {
                color: isDark ? "#FFFFFF" : "#3D5CFD",
              },
            }}
          >
            <Icon size={18} strokeWidth={1.8} />
          </Box>
        )}
        <Typography
          sx={{
            fontSize: "0.8rem",
            fontWeight: 700,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: isDark ? "#A1A1AA" : "#64748b",
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Section items */}
      <Box>{children}</Box>
    </Box>
  );
};

export default SettingsSection;
